import React from 'react';

/**
 * MRV KPI card.
 *
 * Tailwind classes are written as full literals (no string concatenation)
 * so the JIT compiler keeps the styles in the build.
 */

const ACCENT_STYLES = {
  emerald: { bg: 'bg-emerald-50',  text: 'text-emerald-700',  iconBg: 'bg-emerald-100',  iconText: 'text-emerald-600' },
  blue:    { bg: 'bg-blue-50',     text: 'text-blue-700',     iconBg: 'bg-blue-100',     iconText: 'text-blue-600' },
  amber:   { bg: 'bg-amber-50',    text: 'text-amber-700',    iconBg: 'bg-amber-100',    iconText: 'text-amber-600' },
  violet:  { bg: 'bg-violet-50',   text: 'text-violet-700',   iconBg: 'bg-violet-100',   iconText: 'text-violet-600' },
  red:     { bg: 'bg-red-50',      text: 'text-red-700',      iconBg: 'bg-red-100',      iconText: 'text-red-600' },
  gray:    { bg: 'bg-gray-50',     text: 'text-gray-700',     iconBg: 'bg-gray-100',     iconText: 'text-gray-600' },
};

export default function MrvKpiCard({ title, value, sub, Icon, accent = 'gray', loading }) {
  const a = ACCENT_STYLES[accent] || ACCENT_STYLES.gray;
  if (loading) {
    return (
      <div className={`p-4 rounded-lg border border-gray-200 ${a.bg} animate-pulse`}>
        <div className="h-3 w-24 bg-gray-200 rounded mb-2" />
        <div className="h-7 w-32 bg-gray-200 rounded mb-1" />
        <div className="h-3 w-40 bg-gray-200 rounded" />
      </div>
    );
  }
  return (
    <div className={`p-4 rounded-lg border border-gray-200 ${a.bg} hover:shadow-sm transition-shadow`}>
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <div className={`text-xs font-semibold uppercase tracking-wide ${a.text} mb-1`}>{title}</div>
          <div className="text-2xl font-bold text-gray-900 truncate">{value}</div>
          {sub && <div className="text-xs text-gray-500 mt-1">{sub}</div>}
        </div>
        {Icon && (
          <div className={`w-9 h-9 rounded-md ${a.iconBg} flex items-center justify-center flex-shrink-0 ml-2`}>
            <Icon className={`w-4 h-4 ${a.iconText}`} />
          </div>
        )}
      </div>
    </div>
  );
}
